export const CalloutWidth = 700;
